// @ts-nocheck
import {Column} from 'react-table'
import {UserCustomHeader} from '../../apps/user-management/users-list/table/columns/UserCustomHeader'
import {ProductUnit, deleteUnit} from './api'
import {KTIcon} from '../../../../_metronic/helpers'
import {Modal} from 'react-bootstrap'
import {toast} from 'react-hot-toast'
import {useState} from 'react'
import {useLayout} from '../../../../_metronic/layout/core'

const getUnitColumns = (
  setShowForm: React.Dispatch<React.SetStateAction<boolean>>,
  setEditUnit: React.Dispatch<React.SetStateAction<ProductUnit | undefined>>
): ReadonlyArray<Column<ProductUnit>> => [
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Unit Name'
        className='min-w-150px ps-4 text-center'
      />
    ),
    id: 'unit_name',
    accessor: 'unit_name',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Abbreviation'
        className='min-w-125px text-center'
      />
    ),
    accessor: 'abbreviation',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='min-w-100px text-center' />
    ),
    accessor: 'actions',
    sortable: false,
    Cell: ({...props}) => {
      const {company} = useLayout()
      const [showDeleteModal, setShowDeleteModal] = useState(false)

      const handleDelete = async () => {
        deleteUnit(company.value, props.data[props.row.index].unit_name)
          .then((res) => res?.detail && toast.success(res.detail))
          .catch((err) => err && toast.error(err))
          .finally(() => setShowDeleteModal(false))
      }

      const handleEdit = () => {
        setShowForm(true)
        setEditUnit(props.data[props.row.index])
      }

      return (
        <>
          <div className='d-flex justify-content-center flex-shrink-0'>
            <div
              onClick={handleEdit}
              data-bs-toggle='tooltip'
              data-bs-trigger='hover'
              data-bs-dismiss-='click'
              title='Edit'
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </div>
            <div
              data-bs-toggle='tooltip'
              data-bs-trigger='hover'
              data-bs-dismiss-='click'
              title='Delete'
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
              onClick={() => setShowDeleteModal(true)}
            >
              <KTIcon iconName='trash' className='fs-3' />
            </div>
          </div>

          <Modal
            className='modal-sticky modal-sticky-lg modal-sticky-bottom-right'
            id='delete_unit'
            role='dialog'
            data-backdrop='false'
            aria-hidden='true'
            tabIndex='-1'
            show={showDeleteModal}
            animation={false}
          >
            <div className='modal-content'>
              <div className='d-flex align-items-center justify-content-between py-5 ps-8 pe-5 border-bottom'>
                <h5 className='fw-bold m-0'>Delete Unit</h5>
                <div className='d-flex ms-2'>
                  <div
                    className='btn btn-icon btn-sm btn-light-primary ms-2'
                    data-bs-dismiss='modal'
                    onClick={() => setShowDeleteModal(false)}
                  >
                    <KTIcon className='fs-1' iconName='cross' />
                  </div>
                </div>
              </div>
              <div className='text-center py-5 px-5'>
                Are you sure you want to delete this Unit? Please note the Unit can only be deleted
                if there are no products under this Unit.
              </div>
              <div className='text-center pt-5 pb-5'>
                <button
                  type='reset'
                  onClick={() => setShowDeleteModal(false)}
                  className='btn btn-light me-3'
                  data-kt-users-modal-action='cancel'
                >
                  Cancel
                </button>
                <button
                  type='submit'
                  className='btn btn-primary'
                  data-kt-users-modal-action='submit'
                  onClick={handleDelete}
                >
                  Proceed
                </button>
              </div>
            </div>
          </Modal>
        </>
      )
    },
  },
]

export {getUnitColumns}
